function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: -89,
  y: -106,
  width: 714,
  height: 584,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 3,
  fill: "#F08B04"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.99063 5.13737C8.9968 5.09246 8.99998 5.0466 8.99998 5C8.99998 4.44772 8.55227 4 7.99999 4C7.4477 4 6.99999 4.44772 6.99999 5C6.99999 5.0466 7.00318 5.09246 7.00935 5.13737C6.37329 5.32997 5.90333 5.71309 5.58068 6.2099C5.13087 6.90251 5.00001 7.76386 5.00001 8.5C5.00001 9.05213 4.80865 9.27937 4.68538 9.37917C4.61422 9.43678 4.54305 9.4697 4.49134 9.48777C4.46582 9.49669 4.44651 9.50147 4.43652 9.50364L4.43087 9.5048C4.1732 9.54069 3.98539 9.76884 4.00089 10.0297C4.01659 10.2938 4.23539 10.5 4.50001 10.5H11.5C11.7646 10.5 11.9834 10.2938 11.9991 10.0297C12.0146 9.76884 11.8268 9.54069 11.5691 9.5048L11.5635 9.50364C11.5535 9.50147 11.5342 9.49669 11.5087 9.48777C11.457 9.4697 11.3858 9.43678 11.3146 9.37917C11.1914 9.27937 11 9.05213 11 8.5C11 7.76386 10.8691 6.90251 10.4193 6.2099C10.0967 5.71309 9.6267 5.32996 8.99063 5.13737ZM11.5691 9.5048L11.5703 9.50502L11.5672 9.50455L11.5691 9.5048ZM6.41933 6.75457C6.11915 7.21678 6.00001 7.85542 6.00001 8.5C6.00001 8.90195 5.92738 9.23193 5.80958 9.5H10.1904C10.0726 9.23193 9.99999 8.90195 9.99999 8.5C9.99999 7.85542 9.88085 7.21678 9.58067 6.75457C9.3025 6.32625 8.83935 6 8 6C7.16065 6 6.6975 6.32625 6.41933 6.75457ZM11.5605 9.50367L11.5672 9.50455L11.5638 9.5041L11.5617 9.50382L11.5605 9.50367Z",
  fill: "#FFEDC3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.13377 11.5C7.04869 11.3529 6.99999 11.1821 6.99999 11H8.99998C8.99998 11.1821 8.95129 11.3529 8.8662 11.5C8.6933 11.7989 8.37013 12 7.99999 12C7.62985 12 7.30668 11.7989 7.13377 11.5Z",
  fill: "#FFEDC3"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 5.77777,
  y: 5.77777,
  width: 4.44444,
  height: 4.44444,
  rx: 1,
  fill: "#FFEDC3"
});

var SvgTxInitialized = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTxInitialized, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tx-initialized.c63f9126.svg";
export { ForwardRef as ReactComponent };